module.exports = __webpack_public_path__ + "img/route-port-elizabeth.55f0bbea.webp";